import React, { Fragment, useState, useEffect, useContext } from 'react'
import debounce from 'debounce'
import { store } from '../../stores/templates'
import Filter from '../shared/Filter'
import StickyBar from '../shared/StickyBar'
import { ButtonGroup, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { generatePath, useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'

export default function TemplatesFilter(props) {
  const { plans, isAdmin, subscribed, subscriptionLink, subscriptionTier, onChange, active, feature } = props
  const { humanName, hideFilters } = useContext(store)
  const [query, setQuery] = useState('')
  const debouncedSetQuery = debounce(setQuery, 200)
  const planNames = Object.keys(plans).reverse()
  const routeMatches = useParams()

  const currentPlan = routeMatches.plan

  const navigate = useNavigate()

  useEffect(() => {
    if (onChange) {
      onChange(query)
    }
  }, [query])

  const subscribeButton = !subscribed && isAdmin ? (
    <Col xs="12" md="auto" className="mt-2 mt-md-0 px-2 ps-md-0">
      <a href={subscriptionLink} className="btn btn-primary d-block d-md-inline-block">Subscribe from $60/mo</a>
    </Col>
  ) : null

  const upgradeButton = subscribed && isAdmin && subscriptionTier < plans[currentPlan] ? (
    <Col xs="12" md="auto" className="mt-2 mt-md-0 px-2 ps-md-0">
      <a href={subscriptionLink} className="btn btn-primary d-block d-md-inline-block">Upgrade subscription</a>
    </Col>
  ) : null

  return (
    <Fragment>
      <StickyBar>
        <Filter
          query={query}
          onChange={debouncedSetQuery}
          title={`Filter ${humanName.toLowerCase()}s (eg. gameday, birthday, instagram)…`} />
        {!hideFilters && (
          <Col xs="auto" className="px-2">
            <UncontrolledDropdown>
              <DropdownToggle caret color="link" className="p-2 m-n2 text-muted">
                {!feature && 'All Features'}
                {feature == 'events' && 'Events'}
                {feature == 'opponents' && 'Opponents Library'}
                {feature == 'players' && 'Player Database'}
              </DropdownToggle>
              <DropdownMenu end={true}>
                <DropdownItem className={`${!feature && 'bg-gray'}`} onClick={() => {
                  const path = generatePath('/:plan/:category?/:template?', {
                    ...routeMatches,
                    plan: currentPlan,
                  })
                  navigate(path)
                }}>All Features</DropdownItem>
                <DropdownItem className={`${feature == 'events' && 'bg-gray'}`} onClick={() => navigate(`/${currentPlan}/events`)}>Events</DropdownItem>
                <DropdownItem className={`${feature == 'opponents' && 'bg-gray'}`} onClick={() => navigate(`/${currentPlan}/opponents`)}>Opponents Library</DropdownItem>
                <DropdownItem className={`${feature == 'players' && 'bg-gray'}`} onClick={() => navigate(`/${currentPlan}/players`)}>Player Database</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Col>
        )}
        {subscribeButton}
        {upgradeButton}
        <Col xs="12" md="auto" className="mt-2 mt-md-0 px-2 ps-md-1">
          <ButtonGroup className="d-flex">
            {planNames.map(plan => {
              const color = plan == currentPlan ? 'primary' : 'outline-secondary'
              const path = generatePath('/:plan/:category?/:template?', {
                ...routeMatches,
                plan,
              })
              return <Link key={plan} to={path} className={`btn btn-${color} text-capitalize w-100`}>{plan}</Link>
            })}
            <Link to="/active" className={`btn btn-${active ? 'primary' : 'outline-secondary'} text-capitalize w-100 text-nowrap`}>My {humanName}s</Link>
          </ButtonGroup>
        </Col>
      </StickyBar>
    </Fragment>
  )
}
